"use strict";
exports.__esModule = true;
exports.getData = exports.getType = exports.isInputType = void 0;
exports.isInputType = function (s) {
    var arr = ['email', 'password', 'tel', 'text'];
    return arr.includes(s);
};
exports.getType = function (type) {
    switch (type) {
        case 'email':
            return 'email';
        case 'password':
            return 'password';
        case 'tel':
            return 'tel';
        default:
            return 'text';
    }
};
exports.getData = function (name, data) {
    if (data) {
        var v = data[name];
        if (v) {
            return String(v);
        }
    }
    return '';
};
